<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1">
              <router-link  to="/">{{$t("nav.home")}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-2 almarai-bold" aria-current="page">
              {{$t("passwordRecovery")}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row justify-content-center card-style">
      <div class="col-12 col-lg-8">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber"/>
        <success v-if="successfuly" :message="successMessage" />

        <!-- begin:forgetPassword -->
        <div class="card border-0" v-if="step == 1">
          <div class="card-body">
            <div class="card-title text-center almarai-bold">
              {{$t('forgetPassword.title_1')}} 
              <i class="fa-solid fa-unlock mx-2"></i>
            </div>
            <form action="" @submit.prevent="forgetPassword">
              <div class="row">
                <div class="col position-R">
                  <label class="text-style p-2"> 
                    {{$t('forgetPassword.title_2')}}
                    <span class="stars">*</span>
                  </label>
                  <span class="phone-icon">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-phone"></i>
                    <i v-else class="fa-solid fa-phone-flip"></i>
                  </span>
                  <input type="text" maxlength="10" v-model="mobile" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                    class="form-control phone-input" :placeholder="$t('forgetPassword.title_2')" 
                  >
                </div>
                <div class="error-feedback red-color fonttext-14" v-if="V$.mobile.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="row pt-5 justify-content-center">
                <div class="col-12 col-md-6">
                  <div v-if="isLoading" class="text-center">
                    <loader />
                  </div>
                  <button v-else type="submit" class="btn-green form-control">{{$t('next')}}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- end:forgetPassword -->

        <!-- begin:resetPassword -->
        <div class="card card-groundcolor br-radius" v-if="step == 2">
          <div class="card-body">
            <div class="card-title text-center almarai-bold">
              {{$t('forgetPassword.title_1')}} 
              <i class="fa-solid fa-unlock mx-2"></i>
            </div>
            <form action="" @submit.prevent="resetPassword">
              <div class="row">
                <div class="col position-R">
                  <label class="text-style p-2">{{$t('forgetPassword.title_2')}}</label>
                  <span class="phone-icon">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-phone"></i>
                    <i v-else class="fa-solid fa-phone-flip"></i>
                  </span>
                  <input type="text" maxlength="10" v-model="mobile" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                    class="form-control phone-input" :placeholder="$t('forgetPassword.title_3')" 
                  >
                </div>
                <div class="error-feedback red-color fonttext-14" v-if="V$.mobile.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label class="text-style p-2"> {{$t('forgetPassword.title_4')}}</label>
                  <input type="text" v-model="code" class="form-control phone-input" >
                </div>
              </div>
              <div class="row">
                <div class="col position-R">
                  <label class="text-style p-2">{{$t('forgetPassword.title_5')}}</label>
                  <input :type="fieldType" maxlength="50" v-model="newPassword" placeholder="**********" class="form-control phone-input">
                  <span v-if="fieldType == 'password'" @click.prevent="togglePassword" class="forgetPassword-eyes">
                    <i class="fa-regular fa-eye-slash"></i>
                  </span>
                  <span v-else  @click.prevent="togglePassword" class="forgetPassword-eyes">
                    <i class="fa-regular fa-eye"></i>
                  </span>
                </div>
              </div>
              <div class="row py-5">
                <div class="col">
                  <div v-if="isLoading" class="text-center">
                    <loader />
                  </div>
                  <button v-else type="submit" class="btn-green form-control almarai-bold">{{$t('send')}}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- end:resetPassword -->
      </div>
    </div>
  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
export default {
  name: "forgetPassword",

  setup () {
    return { V$: useVuelidate() }
  },

  data(){
    return {
      hasError: false,
      message: "",
      isLoading: false,
      errorNumber: 0,
      step: 1,
      mobile: "",
      code: "",
      newPassword: "",
      successMessage: "",
      successfuly: false,
      fieldType: 'password',
      userLang: 'ar',
      validateMessage: this.$t('validateMessage'),
    }
  },

  validations(){
    return {
      mobile: {required},
    }
  },

  methods: {
    async forgetPassword(){
      this.hasError = false;
      const valid = await this.V$.$validate();
      if(!valid){
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      this.$http.post("/api/auth/forgetPasswordRequest",{
        mobile: this.mobile,
      }).then( res => {
        // console.log(res);
        this.step = 2;
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    resetPassword(){
      this.successfuly = false;
      this.hasError = false;
      this.$http.post("/api/auth/resetPassword",{
        mobile: this.mobile,
        code: this.code,
        password: this.newPassword,
      }).then( res => {
        // console.log(res);
        setTimeout(()=> {
          this.successMessage = this.$t('changePassword.confirmMessage');
          this.successfuly = true;
        },400);
        this.$router.replace({path: '/login'});
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    togglePassword(){
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password';
    },
  },
  created(){
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>